import { render } from "./hanuka2026.vue?vue&type=template&id=2295ad38&scoped=true"
import script from "./hanuka2026.vue?vue&type=script&lang=js"
export * from "./hanuka2026.vue?vue&type=script&lang=js"

import "./hanuka2026.vue?vue&type=style&index=0&id=2295ad38&scoped=true&lang=css"

import exportComponent from "/media/rafa/mainDisk/Documents/Raphael/Development/NavigationApplication/efoani/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2295ad38"]])

export default __exports__